export default "__VITE_ASSET__bTthluEy__"